import React, { useEffect } from "react";
import { useState } from "react";
import ReviewersGrid from "@/components/reviewer/ReviewersGrid";
import {
  Checkbox,
  CheckboxGroup,
  Box,
  Flex,
  Heading,
  Stack,
  Button,
  Icon,
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  CloseButton,
} from "@chakra-ui/react";
import { FaSlidersH } from "react-icons/fa";
import NextLink from "next/link";
import { useDisclosure } from "@chakra-ui/react";
import { BiFilterAlt } from "react-icons/bi";
import { MdArrowBack } from "react-icons/md";
import CustomPagination from "@/components/Pagination";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { getUsers, manageSessions } from "store/authSlice";
import firebase from "firebase";
import {updateSessionStatusByFirebase} from "@/lib/db";
const FiltersListSection = ({ industries, industryFilter, services, servicesFilter, skills, skillsFilter, handleIndustryChange, handleServicesChange, handleSkillsChange, handleReset }) => {
  return (<Box
    w={["100%", "100%", "100%", "100%", "100%", "100%"]}
    className="listing-filter"
  >
    <Box className="filter-reset-headings">
      <Box className="filter-text-icon">
        <FaSlidersH />
        <h5 className="heading-color">Filter</h5>
      </Box>
      <Box className="filter-reset-text">
        <Link href="javascript:void(0)" className="gray-color" onClick={() => handleReset()}>
          Reset
        </Link>
      </Box>
    </Box>
    <Box>
      <Accordion allowToggle>
        <AccordionItem>
          <h6>
            <AccordionButton>
              <Box as="span" flex="1" textalign="left">
                Industry
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h6>
          <AccordionPanel pb={4}>
            <CheckboxGroup
              value={industryFilter}
              onChange={handleIndustryChange}
            >
              <Stack direction="column">
                {industries.length > 0 &&
                  industries.map((i, ind) => (
                    <Checkbox
                      checked={industryFilter.includes(i?.name)}
                      key={ind} value={i?.name}>
                      {i?.name}
                    </Checkbox>
                  ))}
              </Stack>
            </CheckboxGroup>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Box>

    <Box className="">
      <Accordion allowToggle>
        <AccordionItem>
          <h6>
            <AccordionButton>
              <Box as="span" flex="1" textalign="left">
                Services
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h6>
          <AccordionPanel pb={4}>
            <CheckboxGroup
              value={servicesFilter}
              onChange={handleServicesChange}>
              <Stack direction={"column"}>
                {services?.length >= 1 &&
                  services.map((i, ind) => (
                    <Checkbox value={i?.name}>{i?.name}</Checkbox>
                  ))}
              </Stack>
            </CheckboxGroup>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Box>

    <Box className="">
      <Accordion allowToggle>
        <AccordionItem>
          <h6>
            <AccordionButton>
              <Box as="span" flex="1" textalign="left">
                Skills
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h6>
          <AccordionPanel pb={4}>
            <CheckboxGroup
              value={skillsFilter}
              onChange={handleSkillsChange}>
              <Stack direction={"column"}>
                {skills?.length >= 1 &&
                  skills.map((i, ind) => (
                    <Checkbox
                      value={i?.name}
                    >
                      {i?.name}
                    </Checkbox>
                  ))}
              </Stack>
            </CheckboxGroup>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Box>
  </Box>);
}
function DrawerExample(props) {
  const { industries, industryFilter, services, servicesFilter, skills, skillsFilter, handleIndustryChange, handleServicesChange, handleSkillsChange, handleReset } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  const reset = () => {
    setSelectedLanguages([]);
    setExpertiseValue(null);
    onClose();
  };
  return (
    <>
      <Button ref={btnRef} onClick={onOpen}>
        Filter <Icon w={5} h={5} as={BiFilterAlt} />
      </Button>
      <Drawer
        className="fliter-modal"
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent className="filter-popup-content listing-main-wrapper">
          <DrawerBody>
            <Box >
              <button className="flex justify-end ml-auto pt-2 pr-2" onClick={onClose}>
                <CloseButton />
              </button>
              <FiltersListSection
                industries={industries}
                industryFilter={industryFilter}
                services={services}
                servicesFilter={servicesFilter}
                skills={skills}
                skillsFilter={skillsFilter}
                handleIndustryChange={handleIndustryChange}
                handleServicesChange={handleServicesChange}
                handleSkillsChange={handleSkillsChange}
                handleReset={handleReset}
              />
              <Box className="drawer-footer">
                <button className="primary" onClick={onClose}>
                  View Filter Results
                </button>
              </Box>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
const ReviewersListing = () => {
  const dispatch=useDispatch();
  const {user,users,skills,services,industries}=useSelector(state=>state.auth);
  const [pageSize] = useState(9);
  const router = useRouter();
  const [page, setPage] = useState(1);
  const params = useSearchParams();
  const search = params.get("search");
  const sindustry = params.get("industry");
  const [searchQuery, setsearchQuery] = useState(search);
  const [searchVal, setsearchVal] = useState(search);
  useEffect(() => {
    if (search) {
      setsearchQuery(search);
      setsearchVal(search)
    }
  }, [search]);
  const [allMentors, setallMentors] = useState([]);
  const [filterMentors, setfilterMentors] = useState([]);
  const firestore = firebase.firestore();
  const db = firestore;
  useEffect(() => {
    const unsubscribe = db.collection("listProfileUpdate").onSnapshot(
      (snapshot) => {
        const updatedData = snapshot.docs.map((doc) => ({
          ...doc.data(),
        }));
        if(updatedData[0]?.update){
          dispatch(getUsers({page:page,limit:pageSize,role:'mentor',status:'verified',userSide:true}));
          dispatch(manageSessions({method:'get'}));
        }
        updateSessionStatusByFirebase(false,false);
      },
      (error) => {
        console.error("Error fetching sessions:", error);
      }
    );

    return () => unsubscribe();
  }, []);
  useEffect(()=>{
    dispatch(getUsers({page:page,limit:pageSize,role:'mentor',status:'verified',userSide:true}));
    dispatch(manageSessions({method:'get'}));
  }, [page,pageSize]);
  const [industryFilter, setIndustryFilter] = useState(sindustry ? [sindustry] : []);
  const [servicesFilter, setServicesFilter] = useState([]);
  const [skillsFilter, setSkillsFilter] = useState([]);


  // for sidebar filtersss
  const handleIndustryChange = (value) => {
    setIndustryFilter(value);
  };

  const handleServicesChange = (value) => {
    setServicesFilter(value);
  };

  const handleSkillsChange = (value) => {
    setSkillsFilter(value);
  };
  useEffect(() => {
    if (users) {
      let queryMentors = users.filter((i) => ((i?.role !== "owner") && (i._id !== user?._id) && i?.is_activated && i?.is_applied && i?.is_approved && i?.services?.length > 0));
      queryMentors = queryMentors.filter((user) => {
        let industry = (user?.industry?.findIndex((userSkl) => (industryFilter?.length === 0) || industryFilter.includes(userSkl.name)) >= 0);
        let service = (user?.services?.findIndex((userSkl) => (servicesFilter?.length === 0) || servicesFilter.includes(userSkl.name)) >= 0);
        let skill = (user?.skills?.findIndex((userSkl) => (skillsFilter?.length === 0) || skillsFilter.includes(userSkl.name)) >= 0);
        return (industry && service && skill);
      });
      if (searchQuery) {
        const query = searchQuery.toLocaleLowerCase();

        queryMentors = queryMentors.filter((user) => {
          const matchesName = user?.first_name?.toLocaleLowerCase().includes(query) ||
            user?.last_name?.toLocaleLowerCase().includes(query);

          const matchesIndustry = user?.industry?.some((ind) =>
            ind.name.toLocaleLowerCase().includes(query)
          );

          const matchesSkills = user?.skills?.some((cf) =>
            cf.name.toLocaleLowerCase().includes(query)
          );
          const matchesJobs = user?.jobs?.some((cf) =>
            cf.title.toLocaleLowerCase().includes(query)
          );
          const matchesServices = user?.services?.some((cf) =>
            cf.name.toLocaleLowerCase().includes(query)
          );
          return matchesName || matchesIndustry || matchesSkills || matchesJobs || matchesServices;
        });
      }
      setfilterMentors(queryMentors);
      setallMentors(queryMentors);
      router.replace(`/reviewers/listing`)
    }
  }, [industryFilter, servicesFilter, skillsFilter, searchQuery,users]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value == "") {
      setfilterMentors(allMentors);

    }
    setsearchQuery(e.target.value);
  };

  const handleReset = () => {
    setSkillsFilter([]);
    setServicesFilter([]);
    setIndustryFilter([]);
    setfilterMentors(allMentors);
  }
  return (
    <>
      <Box className="listing">
        <Box className="find-mentor-bg-wrapper">
          <Box className="find-mentor-searchbar-bg"></Box>

          <Box className="find-mentor-searchbar-wrapper">
            <Box className="container mx-auto">
              <Box className="find-mentor-searchbar">
                <h1 className="text-white">Find Your Mentor</h1>
                <form className="find-mentor-searchbar-form">
                  <label
                    htmlFor="default-search"
                    className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                  >
                    Search
                  </label>
                  <Box className="relative">
                    <input
                      type="search"
                      id="default-search"
                      className="block w-full text-sm rounded-full dark:placeholder-gray-400 dark:text-white"
                      placeholder="Search Industry | Job Title | Skill"
                      onChange={(e) => {
                        setsearchVal(e?.target.value);
                        if (!e?.target.value) {
                          e.preventDefault();
                          handleChange(e)
                        }
                      }}
                      defaultValue={searchVal}
                      name="search-query"
                    />
                    <button
                      type="submit"
                      disabled={!searchVal}
                      className="text-white hover:bg-blue-800 font-medium rounded-full text-sm dark:hover:bg-blue-700 dark-blue-btn"
                      onClick={(e) => { e.preventDefault(); handleChange({ target: { value: searchVal } }) }}
                    >
                      Search
                      <svg
                        className="text-white-500 flex"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 20"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                        ></path>
                      </svg>
                    </button>
                  </Box>
                </form>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          className="listing-main-wrapper"
          w={["100%", "100%", "100%", "100%"]}
        >
          <Box className="container mx-auto">
            {" "}
            <NextLink href="/" passHref className="desktop-back-arrow">
              <Box className="back-to-home">
                <MdArrowBack />
                Back
              </Box>
            </NextLink>
            <Box className="filter-mobile-view">
              <NextLink href="/" passHref>
                <Box className="back-to-home">
                  <MdArrowBack />
                  Back
                </Box>
              </NextLink>
              <DrawerExample
                industries={industries}
                industryFilter={industryFilter}
                services={services}
                servicesFilter={servicesFilter}
                skills={skills}
                skillsFilter={skillsFilter}
                handleIndustryChange={handleIndustryChange}
                handleServicesChange={handleServicesChange}
                handleSkillsChange={handleSkillsChange}
                handleReset={handleReset}
              />
            </Box>
            <Flex className="listing-main-wrapper-row my-5">
              <FiltersListSection
                industries={industries}
                industryFilter={industryFilter}
                services={services}
                servicesFilter={servicesFilter}
                skills={skills}
                skillsFilter={skillsFilter}
                handleIndustryChange={handleIndustryChange}
                handleServicesChange={handleServicesChange}
                handleSkillsChange={handleSkillsChange}
                handleReset={handleReset}
              />
              <Box>
                <Box className="mentor-cards-wrap ">
                  <Heading className="heading" lineHeight="1.1">
                    All our Mentors
                  </Heading>
                  <Flex className="review-card-wrapper mt-25">
                    <ReviewersGrid
                      reviewers={filterMentors?.slice(
                        (page - 1) * pageSize,
                        page * pageSize
                      )}
                    />
                    {(filterMentors?.length === 0) && <Box className="flex items-center text-grey justify-center gap-1 empty-list-text w-100">
                      List is empty!
                    </Box>}
                  </Flex>
                  {filterMentors?.length > pageSize && (
                    <Flex
                      sx={{ display: "flex", alignItems: "center" }}
                      className="paginations"
                    >
                      <CustomPagination
                        className="pagination-bar"
                        totalCount={filterMentors?.length}
                        pageSize={pageSize}
                        currentPage={page}
                        onPageChange={(e) => setPage(e)}
                      />
                    </Flex>
                  )}
                </Box>
              </Box>
            </Flex>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ReviewersListing;
